/** @jsxImportSource react */

export function CongresoActualView() {
  return (
    <div
      className="flex h-full flex-col"
      style={{ backgroundColor: "#F4F8FB" }}
    >
      {/* Main content area - grows to fill space */}
      <div className="flex min-h-0 flex-1 gap-4 p-4">
        {/* Left Panel: Diputados */}
        <div className="flex w-1/2 flex-col rounded-lg border border-slate-200 bg-white">
          {/* Panel Header */}
          <div
            className="shrink-0 border-b border-slate-200 px-4 py-3"
            style={{ backgroundColor: "#E5EDF3" }}
          >
            <h2 className="text-lg font-semibold text-slate-800">
              Cámara de Diputados
            </h2>
          </div>

          {/* Panel Content - takes all available height */}
          <div className="relative flex min-h-0 min-w-0 flex-1">
            {/* Flourish Embed as iframe */}
            <div className="absolute inset-0 flex items-center justify-center p-4">
              <div className="h-full w-full max-w-[800px]">
                <iframe
                  src="https://flo.uri.sh/visualisation/25848735/embed"
                  title="Cámara de Diputados"
                  className="h-full w-full border-0"
                  scrolling="no"
                  sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel: Senadores */}
        <div className="flex w-1/2 flex-col rounded-lg border border-slate-200 bg-white">
          {/* Panel Header */}
          <div
            className="shrink-0 border-b border-slate-200 px-4 py-3"
            style={{ backgroundColor: "#E5EDF3" }}
          >
            <h2 className="text-lg font-semibold text-slate-800">
              Cámara de Senadores
            </h2>
          </div>

          {/* Panel Content - takes all available height */}
          <div className="relative flex min-h-0 min-w-0 flex-1">
            {/* Flourish Embed as iframe */}
            <div className="absolute inset-0 flex items-center justify-center p-4">
              <div className="h-full w-full max-w-[800px]">
                <iframe
                  src="https://flo.uri.sh/visualisation/25848869/embed"
                  title="Cámara de Senadores"
                  className="h-full w-full border-0"
                  scrolling="no"
                  sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
